import { Box } from '@mui/material';
import { colorSet, typography } from '@theme';
import { Text } from '..';

interface ITextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
  boxstyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

export const Textarea = (props: ITextareaProps) => {
  const { placeholder, boxstyle, style, ...textareaProps } = props;

  return (
    <Box
      sx={{
        width: '100%',
        height: '120px',
        padding: '12px 16px',
        resize: 'none',
        borderRadius: '5px',
        border: `1px solid ${colorSet.gray300}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        '&:hover': {
          border: `1px solid ${colorSet.primaryMain}`
        },
        '&:focus-within': {
          border: `1px solid ${colorSet.gray600}`,
          boxShadow: 'none',
          outline: 'none'
        },
        ...boxstyle
      }}
    >
      <textarea
        {...textareaProps}
        placeholder={placeholder}
        style={{
          ...typography.body1,
          width: '100%',
          height: '60px',
          padding: 0,
          outline: 'none',
          resize: 'none',
          border: 'none',
          overflow: 'hidden',
          ...style
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <Text variant="body1" color={colorSet.gray400}>
          {textareaProps.value && typeof textareaProps.value === 'string' ? textareaProps.value.trim().length : 0}/600
        </Text>
      </div>
    </Box>
  );
};
